export const MODULE_NAME = 'Auth'

export const paths = {
  Login: '/login',
  Register: '/register',
  RegisterSuccess: '/register/success',
  setPassword: '/set-password',
}
